import React from 'react';
import { Link } from 'react-router-dom';

const HTOCancelAppointmentSuccess = props => {
    return (
        <div className="booking-cancel-wrapper text-center pd-10 mr-b10 margin-b20">
            <h2 className="fsp16 margin-b20 mr-b20 uppercase text-color-black text-color_black">{props.title}</h2>
            <p className="margin-b25 mr-b20 fs14 fsp14">Your Home Eye Checkup Appointment <strong>{props.orderId}</strong> has been cancelled. We hope to serve you again soon.</p>
            <Link className="hto-btn hto-btn__primary inline-block flex-1" to="/">
                <span className="">Continue Shopping</span>
            </Link>
        </div>
    );
};

export default HTOCancelAppointmentSuccess;
